import styled from 'react-emotion'
import Colors from '../themes/Colors'
import { BaseDin2014 } from '../themes/Fonts/Din2014'

export const BlogPageContainer = styled('div')`
  font-size: 1rem;
`

export const MainLayoutContainer = styled('div')`
  margin-top: 8.5em;
  width: 43.875em;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 100%;
    margin-top: 5.625em;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 100%;
  }
`
export const HeaderContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.25em;
  justify-content: center;
  align-items: center;
`

export const HeaderText = styled('h1')`
  color: #0d1921;
  font-size: 2.006em;
  text-align: center;
  color: ${props => props.theme.primaryTextColor};
  line-height: 1.38;
  letter-spacing: normal;
  font-family: 'PT Serif', serif;
  font-weight: bold;
  @media (min-width: 320px) and (max-width: 425px) {
    font-size: 1.714em;
  }
`
export const CaptionText = styled('p')`
  color: #0d1921;
  font-size: 1em;
  font-weight: normal;
  font-family: 'PT Serif', serif;
  color: ${props => props.theme.primaryTextColor};
  opacity: 0.6;
  text-align: center;
  margin-left: 3.75em;
  margin-right: 3.75em;
  margin-top: 0.625em;
  line-height: 1.56;
  @media (min-width: 320px) and (max-width: 425px) {
    font-size: 1em;
    line-height: 1.71;
    margin-left: auto;
    margin-right: auto;
  }
`

export const ProfileContainer = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: 1.25em;
  justify-content: center;
`
export const ProfilePic = styled('img')`
  width: 3.75em;
  height: 3.75em;
  object-fit: cover;
  border-radius: 100%;
`
// TODO: Need to check
export const NameContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 0.625em;
  justify-content: center;
`
// color: ${props => props.theme.primaryTextColor};
export const NameText = styled('p')`
  font-family: din-2014;
  font-size: 0.875em;
  font-weight: 600;
  text-align: left;
  color: #0d1921;
  margin-bottom: 0px;
  margin-top: 0px;
  line-height: 1.42;
`
export const DesignationText = styled(BaseDin2014)`
  font-size: 0.75em;
  color: ${Colors.charcoalGrey};
  text-align: left;
  line-height: 1.42;
  margin-bottom: 0px;
  margin-top: 0px;
`
export const StatusContainer = styled('div')`
  display: flex;
  width: 10em;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const DateText = styled(BaseDin2014)`
  font-size: 0.75em;
  text-align: left;
  color: ${Colors.charcoalGrey};
  margin-bottom: 0px;
  margin-top: 0px;
`

export const Dot = styled('span')`
  background-color: ${Colors.charcoalGrey};
  height: 0.214em;
  width: 0.214em;
  border-radius: 50%;
  display: inline-block;
`

export const ReadingTime = styled('p')`
  font-family: din-2014;
  font-size: 0.75em;
  text-align: left;
  color: ${Colors.charcoalGrey};
  margin-bottom: 0px;
  margin-top: 0px;
`

export const BlogHeroImage = styled('img')`
  height: 31.25em;
  width: 100%;
  object-fit: contain;
  @media (min-width: 320px) and (max-width: 425px) {
    height: 8.929em;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    height: 7.813em;
  }
`

export const BodyLayoutContainer = styled('div')`
  margin-top: 3.75em;
  width: 43.875em;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 100%;
    margin-top: 1.25em;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 100%;
    margin-top: 1.25em;
  }
  margin-left: auto;
  margin-right: auto;
`
export const FooterLayoutContainer = styled('div')`
  margin-top: 6.25em;
  width: 43.875em;
  @media (min-width: 320px) and (max-width: 425px) {
    width: 100%;
    margin-top: 3.75em;
  }
  @media (min-width: 426px) and (max-width: 767px) {
    width: 100%;
    margin-top: 3.75em;
  }
  margin-left: auto;
  margin-right: auto;
`
export const FooterDivider = styled('div')`
  width: 100%;
  border: 1px solid;
  color: #d7e3f3;
`
export const IconWrapperContainer = styled('div')`
  display: flex;
  flex-direction: row;
  max-width: 15.625em;
  height: 2.25em;
  justify-content: space-around;
  margin-bottom: 1.25em;
  margin-left: auto;
  margin-right: auto;
`

export const ShareAricleContainer = styled('span')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.25em;
  margin-bottom: 0.625em;
`

export const SignatureContainer = styled('div')`
  margin-top: 2.5em;
  margin-bottom: 2.5em;
`

export const NewsHeading = styled('h1')`
  font-weight: 600;
  font-size: 28px;
`

export const LoaderContainer = styled('div')`
  height: 70vh;
  background: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/templates/styledComponents.js